/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  global-require,
  import/no-extraneous-dependencies,
  no-void
*/
import React from 'react';
import { FormattedMessage, FormattedHTMLMessage, defineMessages, injectIntl } from 'react-intl';
import ContentButton from 'signer/components/common/content-button';
import Image from 'common/components/image';
import logger from 'common/logger';
import HelloSign from 'common/utils/hellosign';
import HfReactHelper from 'common/utils/hf-react-helper';
import createReactClass from 'create-react-class';
import { messages, postMessage } from 'common/utils/messages';

require('./index.scss');

const hsMessages = defineMessages({
  thanks: {
    id: 'signer.complete.inPerson.thanks',
    description: 'text in signer in person flow, thanking signer fort signing document',
    defaultMessage: 'Thanks for signing this document!',
  },
  thanksMessage: {
    id: 'signer.complete.thanksMessage',
    description: 'generic greeting text for submitting the document',
    defaultMessage: 'Thanks for submitting your document!',
  },
});

const SignatureRequestComplete = createReactClass({

  getInitialState() {
    const shortGuid = this.props.app.templateShortGuid;
    return {
      formComplete: false,
      isLoading: false,
      emailAddress: this.props.app.signatureRequest.signer.emailAddress,
      templateShortGuid: shortGuid || void 0,
    };
  },

  closeIFrame() {
    if (!this.props.app.isEmbedded()) {
      return;
    }

    HelloSign.XWM.send('user-done', this.props.location.state.signatureRequest.embeddedData.parentUrl);

    postMessage({
      type: messages.USER_FINISH_REQUEST,
    }, this.props.app.signatureRequest.embeddedData.parentUrl);
  },

  componentDidMount() {
    logger.track('SignatureRequestComplete.componentDidMount');
  },

  onEmailChange(e) {
    this.setState({ emailAddress: e.target.value.trim() });
  },

  /**
   * This is necessary because clicking a link will open a new window
   * when using full-screen web clips on iOS
   */
  onSignAgain(e) {
    e.preventDefault();
    window.location = e.currentTarget.href;
  },

  onSubmit(e) {
    e.preventDefault();

    // Validate email
    if (!HfReactHelper.isValidEmailAddress(this.state.emailAddress)) {
      this.setState({
        errors: { named: { email_address: 'Please enter a valid email address' } },
        hasErrors: true,
      });
      return;
    }

    this.setState({
      errors: null,
      hasErrors: false,
    });

    this.submitAsync();
  },

  /**
    * render methods
    */
  renderThankYou() {
    const isEmbedded = this.props.app.isEmbedded();
    const isDesktop = this.props.app.isDesktop;
    const isInPerson = this.state.templateShortGuid;

    const checkmarkIcon = <i className='ion-ios-checkmark-outline'></i>;
    const checkmarkImage = <Image src={require('./confirmation_check_@2x.png')} />;

    const iFrameCloseButton = <ContentButton className='whitelabel-secondary-button' {...this.props} onClick={this.closeIFrame}>
      <FormattedMessage
        id="common.closeButton.labelText"
        description="button text of iFrame , clicking will close iFrame"
        defaultMessage="Close" />
    </ContentButton>;

    const additionalMsg = (
      <span className='m-signature-request-complete--header-will-receive'>
        <FormattedMessage
          FormattedMessage
          id="signer.complete.willReceiveCopyMessage"
          description="text in signer flow, informing that signer will receive copy of signed document in email shortly"
          defaultMessage="You'll receive a copy in your inbox shortly." />
      </span>
    );

    const settingsWriteBackMessage = (
      <div className="m-signature-request-complete--header-write-back">
        <span className="m-signature-request-complete--header-write-back-cta">
          <FormattedMessage
            id=""
            description="signer app, last step of signature signing, informing user that they can write back information from signature to their account settings"
            defaultMessage="Save time on your next signature request by saving these updates to your profile." />
        </span>
        <a href="/home/myAccount?current_tab=profile" target="_blank" rel="noopener noreferrer">
          <ContentButton className="m-signature-request-complete--header-write-back-button whitelabel-secondary-button" {...this.props}>
            <FormattedMessage
              id=""
              description="signer app, last step of signature signing, button, redirects user to profile settings"
              defaultMessage="Go to my profile" />
          </ContentButton>
        </a>
      </div>
    );

    const farewellMsg = <div className='m-signature-request-complete--header-farewell'>
      <FormattedMessage
        id="signer.complete.inPerson.farewell"
        description="text in signer flow, greeting signer to have good day after the signing of document is complete"
        defaultMessage="Have a fantastic day." />
    </div>;

    const aboutText = <span className='m-signature-request-complete--about-cta'>
      <FormattedHTMLMessage
        id="signer.complete.aboutHelloSignMessage"
        description="text in signer flow, marketing information to signer saying to use HelloSign to send the online signature"
        defaultMessage="Need someone to sign a document? <br /> Send it with HelloSign."
        values={{
          br: <br />,
        }} />
    </span>;

    return <div className='m-signature-request-complete'>
      <div className='m-signature-request-complete--header whitelabel-secondary-header'>
        { isEmbedded && isDesktop ? checkmarkImage : void 0 }
        <span className='m-signature-request-complete--header-title'>
          { isEmbedded && isDesktop ? void 0 : checkmarkIcon }
          {isInPerson
            ? this.props.intl.formatMessage(hsMessages.thanks)
            : this.props.intl.formatMessage(hsMessages.thanksMessage)}
        </span>
        { isEmbedded ? void 0 : additionalMsg }
        { !isEmbedded && this.props.location.canWriteBack ? settingsWriteBackMessage : void 0 }
        { isInPerson ? farewellMsg : void 0 }
        { isEmbedded ? iFrameCloseButton : void 0 }
      </div>
      <div className='m-signature-request-complete--about'>
        { isInPerson ? (
          <a href={`/signer/getStartedInPerson?guid=${this.state.templateShortGuid}`} onClick={this.onSignAgain} rel='noopener noreferrer'>
            <ContentButton className='m-signature-request-complete--about-take-tour-button whitelabel-secondary-button' {...this.props}>
              <FormattedMessage
                id="signer.complete.inPerson.signAgain"
                description="text in signer flow, suggesting signer to start another signature process"
                defaultMessage="Start Another Signature Process" />
            </ContentButton>
          </a>
        ) : (
          <React.Fragment>
            { aboutText }
            <a href="https://www.hellosign.com/features" target="_blank" rel='noopener noreferrer'>
              <ContentButton className='m-signature-request-complete--about-take-tour-button whitelabel-secondary-button' {...this.props}>
                <FormattedMessage
                  id="signer.complete.takeTourButton.labelText"
                  description="link text in signer flow, infomring user to click to know more about the HelloSign"
                  defaultMessage="Learn More" />
              </ContentButton>
            </a>
          </React.Fragment>
        ) }
      </div>
    </div>;
  },

  /**
    * final render
    */

  render() {
    // TODO : Leaving stubbed out so we can add in a loading redirect screen per DEV-276
    return this.renderThankYou();
  },
});

module.exports = injectIntl(SignatureRequestComplete);
